/* eslint-disable react/jsx-props-no-spreading */
import { useUrlGenerator } from '@folklore/routes';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import PageMeta from '../partials/PageMeta';

import styles from '../../../styles/pages/error.module.css';

interface ErrorPageProps {
    statusCode?: number;
    refetch?: (() => void) | null;
}

function ErrorPage({ statusCode = 404, refetch = null }: ErrorPageProps) {
    const route = useUrlGenerator();

    return (
        <div className={styles.container}>
            <PageMeta title={null} />
            <div className={styles.inner}>
                <h1 className={styles.title}>
                    {statusCode === 404 ? (
                        <FormattedMessage defaultMessage="Erreur 404" description="Error title" />
                    ) : (
                        <FormattedMessage defaultMessage="Erreur" description="Error title" />
                    )}
                </h1>
                <p className={styles.description}>
                    <FormattedMessage
                        defaultMessage="Une erreur s'est produite."
                        description="Error message"
                    />
                </p>
                <div className={styles.actions}>
                    {refetch !== null && statusCode !== 404 ? (
                        <button type="button" className="reset-button" onClick={() => refetch()}>
                            <FormattedMessage
                                defaultMessage="Réessayer"
                                description="Retry button label"
                            />
                        </button>
                    ) : null}
                    <Link href={route('home')}>
                        <FormattedMessage
                            defaultMessage="Aller à la page d'accueil."
                            description="Error page home link"
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default ErrorPage;
